import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';
import {
  Dropdown,
  Card,
  Icon,
  Modal,
  Form,
  Grid,
  Input,
  Dimmer,
  Loader
} from "semantic-ui-react";
import { getSiteWiseSplittedFiles, dseFileUpload, fetchMasterData, smartspotDseFileUpload, wholesaleDseFileUpload, wholesaleQPSDseFileUpload } from "../../actions/users_action.js";
import config from "../../config.js";
const storageBaseUrl = config["storage_base_url"];
import ButtonHandler from "../ButtonHandler.jsx";

class DisbursementTabView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDisbursementType: '',
      selectedDisbursementReport: '',
      hotspotData: {},
      modalOpen: false,
      currentFile: {},
      fileName: '',
      templates: [],
      templateId: '',
      disType: ''
    };
  }

  async componentDidMount() {
    console.log(this.props.auth, 'loginId')
    await this.props.fetchMasterData({
      onSuccess: (res) => {
        this.setState({ 'templates': res.templates, 'distributors': res.distributors })
        let tempId = res.templates[-1]._id
        this.setState({ templateId: tempId })
        this.props.getSiteWiseSplittedFiles(this.props.auth.loginId, tempId, {
          onSuccess: (res) => {
            console.log(res, 'resss')
            this.setState({ hotspotData: res.siteData, smartspotData: res.smartspotData, wholeSaleData: res.wholesaleData, wholesaleQpsData: res.wholesaleQPSData })
          },
          onFailure: () => {

          }
        })
      },
      onFailure: () => {

      }
    })
  }

  disbursementTypeOnChange = (e, data) => {
    this.setState({ selectedDisbursementType: data.value })
  }

  disbursementMonthOnChange = (e, data) => {
    data.options.map((d) => {
      if (d.value == data.value) {
        this.setState({ templateId: d.key })
        this.props.getSiteWiseSplittedFiles(this.props.auth.loginId, d.key, {
          onSuccess: (res) => {
            console.log(res, 'resss')
            this.setState({ hotspotData: res.siteData, smartspotData: res.smartspotData, wholeSaleData: res.wholesaleData, wholesaleQpsData: res.wholesaleQPSData })
          },
          onFailure: () => {

          }
        })
      }
    })
    this.setState({ selectMonth: data.value })
  }

  disbursementReportOnChange = (e, data) => {
    this.setState({ selectedDisbursementReport: data.value })
  }

  downloadfile = (url) => {
    window.open(url);
  }

  closeuploadoption = () => {
    this.setState({ modalOpen: false })
  }

  fileupload = (file) => {
    this.setState({ currentFile: file.target.files[0], fileUploaded: true })
  };

  uploadDSEFile = () => {
    this.setState({ loaderStatus: true })
    let file = this.state.currentFile
    let fileName = this.state.fileName
    let userId = this.props.auth.loginId
    let templateId = this.state.templateId
    // console.log(this.state.templateId,'templateId')
    this.props.dseFileUpload(file, fileName, userId, templateId, {
      onSuccess: (res) => {
        alert("File Successfully Uploaded")
        this.props.getSiteWiseSplittedFiles(this.props.auth.loginId, this.state.templateId, {
          onSuccess: (res) => {
            this.setState({ hotspotData: res.siteData, smartspotData: res.smartspotData, wholeSaleData: res.wholesaleData, wholesaleQpsData: res.wholesaleQPSData })
          },
          onFailure: () => {

          }
        })
        this.setState({ modalOpen: false, loaderStatus: false })

      },
      onFailure: () => {

      }
    })
  }

  uploadWholesaleDSEFile = () => {
    this.setState({ loaderStatus: true })
    let file = this.state.currentFile
    let fileName = this.state.fileName
    let userId = this.props.auth.loginId
    let templateId = this.state.templateId
    this.props.wholesaleDseFileUpload(file, fileName, userId, templateId, {
      onSuccess: (res) => {
        alert("File Successfully Uploaded")
        this.props.getSiteWiseSplittedFiles(this.props.auth.loginId, this.state.templateId, {
          onSuccess: (res) => {
            this.setState({ hotspotData: res.siteData, smartspotData: res.smartspotData, wholeSaleData: res.wholesaleData, wholesaleQpsData: res.wholesaleQPSData })
          },
          onFailure: () => {

          }
        })
        this.setState({ modalOpen: false, loaderStatus: false })
      },
      onFailure: () => {

      }
    })
  }

  uploadWholesaleQPSDSEFile = () => {
    this.setState({ loaderStatus: true })
    let file = this.state.currentFile
    let fileName = this.state.fileName
    let userId = this.props.auth.loginId
    let templateId = this.state.templateId
    this.props.wholesaleQPSDseFileUpload(file, fileName, userId, templateId, {
      onSuccess: (res) => {
        alert("File Successfully Uploaded")
        this.props.getSiteWiseSplittedFiles(this.props.auth.loginId, this.state.templateId, {
          onSuccess: (res) => {
            this.setState({ hotspotData: res.siteData, smartspotData: res.smartspotData, wholeSaleData: res.wholesaleData, wholesaleQpsData: res.wholesaleQPSData })
          },
          onFailure: () => {

          }
        })
        this.setState({ modalOpen: false, loaderStatus: false })
      },
      onFailure: () => {

      }
    })
  }

  uploadSmartspotDSEFile = () => {
    let file = this.state.currentFile
    let fileName = this.state.fileName
    let userId = this.props.auth.loginId
    this.props.smartspotDseFileUpload(file, fileName, userId, {
      onSuccess: (res) => {
        alert("File Successfully Uploaded")
        this.setState({ modalOpen: false })
      },
      onFailure: () => {

      }
    })
  }



  uploadFile = async (fileName, disType) => {
    this.setState({ fileName: fileName, modalOpen: true, disType: disType })

  }

  render() {

    var monthsList = []

    if (this.state.templates.length > 0) {
      this.state.templates.map((d) => {
        monthsList.push({
          'key': d._id,
          'value': d.name,
          'text': d.name
        })
      })

    }

    let disbursementTypes = [
      {
        "key": "Corporate Disbursement",
        "value": "Corporate Disbursement",
        "text": "Corporate Disbursement"
      },
      // {
      //     "key":"Lat Incentives",
      //     "value":"Lat Incentives",
      //     "text":"Lat Incentives"
      // },
      // {
      //     "key":"Adhoc Reports",
      //     "value":"Adhoc Reports",
      //     "text":"Adhoc Reports"
      // }
    ]

    return (
      <div style={{ height: "100%", backgroundColor: "white" }}>
        <div style={{ width: "200%" }}>
          <Dimmer active={this.state.loaderStatus}>
            <Loader size="massive">Processing.....</Loader>
          </Dimmer>
          <br />
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div>
              <Dropdown placeholder='Select Month' search selection options={monthsList}
                onChange={this.disbursementMonthOnChange}
                value={this.state.selectMonth}

              />
            </div>

            <div style={{ marginLeft: 30 }}>
              <Dropdown placeholder='Select Disbursement Type' search selection options={disbursementTypes}
                onChange={this.disbursementTypeOnChange}
                value={this.state.selectedDisbursementType}

              />
            </div>
          </div>
        </div>
        {this.state.selectedDisbursementType == 'Corporate Disbursement' &&
          <div>
            <div>
              <br />
              <h1
                style={{
                  paddingLeft: 30,
                  flex: "0 0 30px",
                  display: "inline-block",
                  color: "#2185d0",
                }}
              >
                Hotspot
              </h1>
              <br />
              {console.log(this.state.hotspotData[0], 'hotspot')}
              <Card.Group>
                <Card className="fluid" style={{ width: '100%', height: 125, marginTop: 10, marginLeft: 30, display: 'flex', flexDirection: 'row' }}>
                  <Card.Content>
                    <Card.Header><h3>{'Workings'}</h3></Card.Header>
                    {/* <Card.Description>
                                        <h3>{`Large A&B  `} <Icon name="arrow circle down" style={{ marginLeft: 25, cursor: 'pointer' }} color={'green'}
                                        disabled={this.state.hotspotData[0] && this.state.hotspotData[0].workingReleaseCheck != undefined && this.state.hotspotData[0].workingReleaseCheck == 'Completed' ? false : true} 
                                        onClick={() => this.downloadfile(storageBaseUrl + this.state.hotspotData[0].large)}
                                        />
                                        {this.state.hotspotData.length && this.state.hotspotData[0].workingReleaseCheck !== undefined &&
                                        this.state.hotspotData[0].workingReleaseCheck == 'Completed'  ?
                                        <Icon name="check circle" style={{ marginLeft: 25 }} color={'green'}/> : ''
                                      } 
                                      {this.state.hotspotData.length && this.state.hotspotData[0].workingReleaseCheck !== undefined &&
                                        this.state.hotspotData[0].workingReleaseCheck == 'Completed'  ?
                                        <h3>{this.state.hotspotData[0].releasingDate }</h3>: ''
                                      } 
                                        </h3>
                                        
                                    </Card.Description> */}
                    <Card.Description>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <h3 style={{ margin: 0 }}>{`Large A&B`}</h3>

                        <Icon
                          name="arrow circle down"
                          style={{ marginLeft: 25, cursor: 'pointer' }}
                          color="green"
                          disabled={
                            !(
                              this.state.hotspotData[0] &&
                              this.state.hotspotData[0].workingReleaseCheck !== undefined &&
                              this.state.hotspotData[0].workingReleaseCheck === 'Completed'
                            )
                          }
                          onClick={() =>
                            this.downloadfile(
                              storageBaseUrl + this.state.hotspotData[0]?.large
                            )
                          }
                        />

                        {this.state.hotspotData.length &&
                          this.state.hotspotData[0]?.workingReleaseCheck === 'Completed' && (
                            <>
                              <Icon
                                name="check circle"
                                style={{ marginLeft: 25 }}
                                color="green"
                              />
                              <span style={{ marginLeft: 10 }}>
                                {this.state.hotspotData[0].releasingDate}
                              </span>
                            </>
                          )}
                      </div>
                    </Card.Description>

                    <Card.Description>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <h3 style={{ margin: 0 }}>Medium</h3>

                        <Icon
                          name="arrow circle down"
                          style={{ marginLeft: 45, cursor: 'pointer' }}
                          color="green"
                          disabled={
                            !(
                              this.state.hotspotData[0] &&
                              this.state.hotspotData[0].workingReleaseCheck !== undefined &&
                              this.state.hotspotData[0].workingReleaseCheck === 'Completed'
                            )
                          }
                          onClick={() =>
                            this.downloadfile(
                              storageBaseUrl + this.state.hotspotData[0]?.medium
                            )
                          }
                        />

                        {this.state.hotspotData.length &&
                          this.state.hotspotData[0]?.workingReleaseCheck === 'Completed' && (
                            <>
                              <Icon
                                name="check circle"
                                style={{ marginLeft: 25 }}
                                color="green"
                              />
                              <span style={{ marginLeft: 10 }}>
                                {this.state.hotspotData[0].releasingDate}
                              </span>
                            </>
                          )}
                      </div>
                    </Card.Description>

                  </Card.Content>
                  <br></br>
                  <br></br>
                  <br></br>

                  <br></br>
                  <br></br>
                  <br></br>
                  <Card.Content>
                    <Card.Header><h3>{'Credit Note'}</h3></Card.Header>
                    {console.log(this.state.hotspotData,'hotspot data')}
                    <Card.Description>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <h3 style={{ margin: 0 }}>{`Large A&B`}</h3>

                        <Icon
                          name="arrow circle down"
                          style={{ marginLeft: 25, cursor: 'pointer' }}
                          color="green"
                          onClick={() => this.downloadfile(storageBaseUrl + this.state.hotspotData[0].creditNoteLarge)}
                          disabled={
                            !(
                              this.state.hotspotData[0] &&
                              this.state.hotspotData[0].workingReleaseCheck !== undefined &&
                              this.state.hotspotData[0].workingReleaseCheck === 'Completed'
                            )
                          }
                        />

                        {this.state.hotspotData.length &&
                          this.state.hotspotData[0].creditNoteLarge !== undefined &&
                          this.state.hotspotData[0].creditNoteLarge !== '' && (
                            <>
                              <Icon
                                name="check circle"
                                style={{ marginLeft: 25 }}
                                color="green"
                              />
                              <span style={{ marginLeft: 10 }}>
                                {this.state.hotspotData[0].releasingDate}
                              </span>
                            </>
                          )}
                      </div>
                    </Card.Description>

                    <Card.Description>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <h3 style={{ margin: 0 }}>{`Medium`}</h3>

                        <Icon
                          name="arrow circle down"
                          style={{ marginLeft: 45, cursor: 'pointer' }}
                          color="green"
                          onClick={() => this.downloadfile(storageBaseUrl + this.state.hotspotData[0].creditNoteMedium)}
                          disabled={
                            !(
                              this.state.hotspotData[0] &&
                              this.state.hotspotData[0].workingReleaseCheck !== undefined &&
                              this.state.hotspotData[0].workingReleaseCheck === 'Completed'
                            )
                          }
                        />

                        {this.state.hotspotData.length &&
                          this.state.hotspotData[0].creditNoteMedium !== undefined &&
                          this.state.hotspotData[0].creditNoteMedium !== '' && (
                            <>
                              <Icon
                                name="check circle"
                                style={{ marginLeft: 25 }}
                                color="green"
                              />
                              <span style={{ marginLeft: 10 }}>
                                {this.state.hotspotData[0].releasingDate}
                              </span>
                            </>
                          )}
                      </div>
                    </Card.Description>

                    <br></br>

                  </Card.Content>
                </Card>
              </Card.Group>

            </div>

            <div>
              <br />
              <h1
                style={{
                  paddingLeft: 30,
                  flex: "0 0 30px",
                  display: "inline-block",
                  color: "#2185d0",
                }}
              >
                WholeSale
              </h1>
              <br />
              <Card.Group>
                <Card className="fluid" style={{ width: '100%', height: 125, marginTop: 10, marginLeft: 30, display: 'flex', flexDirection: 'row' }}>
                  <Card.Content>
                    <Card.Header><h3>{'Workings'}</h3></Card.Header>
                    <Card.Description>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <h3 style={{ margin: 0 }}>Working File</h3>

                        <Icon
                          name="arrow circle down"
                          style={{ marginLeft: 25, cursor: 'pointer' }}
                          color="green"
                          disabled={
                            !(
                              this.state.wholeSaleData[0] &&
                              this.state.wholeSaleData[0].workingReleaseCheck !== undefined &&
                              this.state.wholeSaleData[0].workingReleaseCheck === 'Completed'
                            )
                          }
                          onClick={() =>
                            this.downloadfile(
                              storageBaseUrl + this.state.wholeSaleData[0]?.fileUrl
                            )
                          }
                        />

                        {this.state.wholeSaleData.length &&
                          this.state.wholeSaleData[0]?.fileUrl && (
                            <>
                              <Icon
                                name="check circle"
                                style={{ marginLeft: 25, cursor: 'pointer' }}
                                color="green"
                              />
                              <span style={{ marginLeft: 10 }}>
                                {this.state.wholeSaleData[0].releasingDate}
                              </span>
                            </>
                          )}
                      </div>
                    </Card.Description>

                  </Card.Content>
                  <br></br>
                  <br></br>
                  <br></br>

                  <br></br>
                  <br></br>
                  <br></br>
                  <Card.Content>
                    <Card.Header><h3>{'Credit Note'}</h3></Card.Header>
                    <Card.Description>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <h3 style={{ margin: 0 }}>{`CreditNote File`}</h3>

                        <Icon
                          name="arrow circle down"
                          style={{ marginLeft: 25, cursor: 'pointer' }}
                          color="green"
                          onClick={() =>
                            this.downloadfile(storageBaseUrl + this.state.wholeSaleData[0].creditNoteUrl)
                          }
                          disabled={
                            !(
                              this.state.wholeSaleData[0] &&
                              this.state.wholeSaleData[0].workingReleaseCheck !== undefined &&
                              this.state.wholeSaleData[0].workingReleaseCheck === 'Completed'
                            )
                          }
                        />

                        {this.state.wholeSaleData.length &&
                          this.state.wholeSaleData[0].creditNoteUrl !== undefined &&
                          this.state.wholeSaleData[0].creditNoteUrl !== '' && (
                            <>
                              <Icon
                                name="check circle"
                                style={{ marginLeft: 25 }}
                                color="green"
                              />
                              <span style={{ marginLeft: 10 }}>
                                {this.state.wholeSaleData[0].releasingDate}
                              </span>
                            </>
                          )}
                      </div>
                    </Card.Description>

                    <br></br>

                  </Card.Content>
                </Card>
              </Card.Group>

            </div>
            
            <div>
              <br />
              <h1
                style={{
                  paddingLeft: 30,
                  flex: "0 0 30px",
                  display: "inline-block",
                  color: "#2185d0",
                }}
              >
                WholeSale QPS
              </h1>
              <br />
              <Card.Group>
                <Card className="fluid" style={{ width: '100%', height: 125, marginTop: 10, marginLeft: 30, display: 'flex', flexDirection: 'row' }}>
                  <Card.Content>
                    <Card.Header><h3>{'Workings'}</h3></Card.Header>
                    <Card.Description>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <h3 style={{ margin: 0 }}>Working File</h3>

                        <Icon
                          name="arrow circle down"
                          style={{ marginLeft: 25, cursor: 'pointer' }}
                          color="green"
                          disabled={
                            !(
                              this.state.wholesaleQpsData[0] &&
                              this.state.wholesaleQpsData[0].workingReleaseCheck !== undefined &&
                              this.state.wholesaleQpsData[0].workingReleaseCheck === 'Completed'
                            )
                          }
                          onClick={() =>
                            this.downloadfile(
                              storageBaseUrl + this.state.wholesaleQpsData[0]?.fileUrl
                            )
                          }
                        />

                        {this.state.wholesaleQpsData.length &&
                          this.state.wholesaleQpsData[0]?.fileUrl && (
                            <>
                              <Icon
                                name="check circle"
                                style={{ marginLeft: 25, cursor: 'pointer' }}
                                color="green"
                              />
                              <span style={{ marginLeft: 10 }}>
                                {this.state.wholesaleQpsData[0].releasingDate}
                              </span>
                            </>
                          )}
                      </div>
                    </Card.Description>

                  </Card.Content>
                  <br></br>
                  <br></br>
                  <br></br>

                  <br></br>
                  <br></br>
                  <br></br>
                  <Card.Content>
                    <Card.Header><h3>{'Credit Note'}</h3></Card.Header>
                    <Card.Description>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <h3 style={{ margin: 0 }}>{`CreditNote File`}</h3>

                        <Icon
                          name="arrow circle down"
                          style={{ marginLeft: 25, cursor: 'pointer' }}
                          color="green"
                          onClick={() =>
                            this.downloadfile(storageBaseUrl + this.state.wholesaleQpsData[0].creditNoteUrl)
                          }
                          disabled={
                            !(
                              this.state.wholesaleQpsData[0] &&
                              this.state.wholesaleQpsData[0].workingReleaseCheck !== undefined &&
                              this.state.wholesaleQpsData[0].workingReleaseCheck === 'Completed'
                            )
                          }
                        />

                        {this.state.wholesaleQpsData.length &&
                          this.state.wholesaleQpsData[0].creditNoteUrl !== undefined &&
                          this.state.wholesaleQpsData[0].creditNoteUrl !== '' && (
                            <>
                              <Icon
                                name="check circle"
                                style={{ marginLeft: 25 }}
                                color="green"
                              />
                              <span style={{ marginLeft: 10 }}>
                                {this.state.wholesaleQpsData[0].releasingDate || ''}
                              </span>
                            </>
                          )}
                      </div>
                    </Card.Description>

                    <br></br>

                  </Card.Content>
                </Card>
              </Card.Group>

            </div>
            {/* <div>
              <br />
              <h1
                style={{
                  paddingLeft: 30,
                  flex: "0 0 30px",
                  display: "inline-block",
                  color: "#2185d0",
                }}
              >
                WholeSale SmartQPS
              </h1>
              <br />
              <Card.Group>
                <Card className="fluid" style={{ width: '100%', height: 125, marginTop: 10, marginLeft: 30, display: 'flex', flexDirection: 'row' }}>
                  <Card.Content>
                    <Card.Header><h3>{'Workings'}</h3></Card.Header>
                    <Card.Description>
                      {console.log(this.state.wholesaleQpsData, 'qps')}
                      <h3>{` \Working File  `} <Icon name="arrow circle down" style={{ marginLeft: 25, cursor: 'pointer' }} color={'green'}
                        onClick={() => this.downloadfile(storageBaseUrl + this.state.wholesaleQpsData[0].fileUrl)}
                        disabled={this.state.wholesaleQpsData[0] && this.state.wholesaleQpsData[0].workingReleaseCheck != undefined && this.state.wholesaleQpsData[0].workingReleaseCheck == 'Completed' ? false : true}
                      />
                        {this.state.wholesaleQpsData.length && this.state.wholesaleQpsData[0].fileUrl != undefined &&
                          this.state.wholesaleQpsData[0].fileUrl != '' ?
                          <Icon name="check circle" style={{ marginLeft: 25, cursor: 'pointer' }} color={'green'} /> : ""
                        }

                      </h3>
                    </Card.Description>
                  </Card.Content>
                  <br></br>

                  <br></br>
                  <br></br>
                  <Card.Content>
                    <Card.Header><h3>{'Credit Note'}</h3></Card.Header>
                    <Card.Description>
                      <h3>{`CreditNote File `}<Icon name="arrow circle down" style={{ marginLeft: 25, cursor: 'pointer' }} color={'green'}
                        onClick={() => this.downloadfile(storageBaseUrl + this.state.wholesaleQpsData[0].creditNoteUrl)}
                        disabled={this.state.wholesaleQpsData[0] && this.state.wholesaleQpsData[0].workingReleaseCheck != undefined && this.state.wholesaleQpsData[0].workingReleaseCheck == 'Completed' ? false : true}
                      />
                        {this.state.wholesaleQpsData.length && this.state.wholesaleQpsData[0].creditNoteUrl != undefined &&
                          this.state.wholesaleQpsData[0].creditNoteUrl != '' ?
                          <Icon name="check circle" style={{ marginLeft: 25 }} color={'green'} /> : ''
                        }
                      </h3>
                    </Card.Description>
                    <br></br>

                  </Card.Content>
                </Card>
              </Card.Group>

            </div> */}
          </div>

        }


        <Modal
          open={this.state.modalOpen}
          onClose={this.closeuploadoption}
          size="mini"
        >
          <Modal.Content>
            <Form>
              <Grid columns={1}>
                <Grid.Row>

                  <Grid.Column style={{ marginTop: 20 }}>
                    <h4>Upload Master data :</h4>
                    <Input
                      type="file"
                      accept=".xlsx"
                      onChange={this.fileupload}
                      multiple
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Form>
          </Modal.Content>

          <Modal.Actions>
            <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
              <ButtonHandler
                click={this.state.disType === 'Hotspot'
                  ? this.uploadDSEFile
                  : this.state.disType === 'Wholesale'
                    ? this.uploadWholesaleDSEFile
                    : this.state.disType === 'WholesaleQPS'
                      ? this.uploadWholesaleQPSDSEFile
                      : this.uploadSmartspotDSEFile}
                title={'Upload'}
                color={'green'}
                iconColor={'white'}
                disabled={this.state.fileUploaded == true ? false : true}
              />
              <ButtonHandler
                click={this.closeuploadoption}
                isIcon={true}
                color={'red'}
                iconName={'remove'}
                iconColor={'white'}
                title={'Close'}
              />
            </div>

          </Modal.Actions>
          {this.state.loaderStatus && (
            <Dimmer active inverted>
              <Loader inverted>Loading</Loader>
            </Dimmer>
          )}
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getSiteWiseSplittedFiles,
      dseFileUpload,
      fetchMasterData,
      smartspotDseFileUpload,
      wholesaleDseFileUpload,
      wholesaleQPSDseFileUpload
    },
    dispatch
  );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DisbursementTabView));